import axios from "axios";
import { AlertConstants } from "../constants/AlertConstants";
import { AuthConstants } from "../constants/AuthConstants";

function createErrorMessage(error) {
  switch (error.response.status) {
    case 403:
      return "You do not have the correct permission to do this action";
    case 404:
      return "Resource not found";
    default:
      return "Comptix error please contact support: " + error.message;
  }
}

class HttpInterceptor {
  constructor(authStore, alertStore) {
    axios.interceptors.request.use(
      async config => {
        const url = config.url || "";
        if (url.indexOf("/oauth/token") < 0 || config.headers?.addToken) {
          const accessToken = await authStore.getBearerToken();
          config.headers = config.headers || {};
          if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
          }
        }
        return config;
      },
      error => {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      response => {
        if (response && response.data && response.data.alerts) {
          alertStore.createResponseAlerts(response.data.alerts);
        }
        return response;
      },
      error => {
        if (error) {
          const response = error.response;
          const originalRequest = error.config || {};
          const isOktaSession = authStore.authSource === AuthConstants.SOURCES.OKTA;
          const isInvalidToken = response && response.data && "invalid_token" === response.data.error;

          if (isOktaSession && (response?.status === 401 || isInvalidToken) && !originalRequest.oktaRetry) {
            originalRequest.oktaRetry = true;
            return authStore.refreshOktaAccessToken().then(accessToken => {
              if (accessToken) {
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers.Authorization = `Bearer ${accessToken}`;
                return axios(originalRequest);
              }
              authStore.logout();
              return Promise.reject(error);
            });
          }

          if (!isOktaSession && isInvalidToken) {
            authStore.refresh();
            return Promise.reject(error);
          } else if (
            !isOktaSession &&
            ((response && response.data && "invalid_grant" === response.data.error) ||
              response?.status === 401 ||
              response?.status === 403)
          ) {
            authStore.logout();
            return Promise.reject(error);
          } else {
            if (error) {
              if (error.response && error.response.data) {
                if (error.response.data.alerts) {
                  alertStore.createResponseAlerts(error.response.data.alerts);
                } else {
                  let message = createErrorMessage(error);
                  alertStore.addAlert({
                    type: AlertConstants.TYPES.DANGER,
                    text: message
                  });
                }
              }
              return Promise.reject(error);
            }
          }
        }
      }
    );
  }
}

export default HttpInterceptor;
